'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventRotationRoutes = [
  {
    path: 'rotations',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.rotation.list',
        props: true,
        component: () => import('../views/RotationListView.vue'),
      },
      // {
      //   path: ':rotationId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.rotation.detail',
      //       component: () => import('../views/RotationDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageRotationRoutes = [
  {
    path: 'rotations',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.rotation.list',
        props: true,
        component: () => import('../views/ManageRotationListView.vue'),
      },
      {
        path: 'save',
        name: 'event.manage.rotation.save',
        props: true,
        component: () => import('../views/ManageRotationSaveView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.rotation.add',
        props: (route) => ({
          eventUrl: route.params.eventUrl,
          group: route.query.group,
          session: parseInt(route.query.session),
        }),
        component: () => import('../views/ManageRotationAddView.vue'),
      },
      {
        path: ':rotationId',
        component: EmptyRouterView,
        props: true,
        children: [
          {
            path: 'edit',
            name: 'event.manage.rotation.edit',
            props: true,
            component: () => import('../views/ManageRotationEditView.vue'),
          },
        ],
      },
    ],
  },
];
